function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapQualito({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61.758 80.166",
    width: 45,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1, 0, 0, 1, -75.955505, -104.190567)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.31139946
    },
    id: "path630",
    cx: 107.46031,
    cy: 135.85776,
    rx: 23.36812,
    ry: 24.166615
  }), /*#__PURE__*/React.createElement("g", {
    id: "g382",
    transform: "matrix(1.1964935,0,0,1.1992177,45.77402,-82.020203)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f48d1e",
      strokeWidth: 0.26458332
    },
    d: "m 38.897474,191.65894 c -0.661018,-0.26672 -0.301316,-1.25759 1.078281,-2.97032 0.774956,-0.96208 2.739487,-3.50615 4.365625,-5.65348 l 2.956615,-3.90423 V 173.459 c 0,-6.90725 -0.255206,-6.49566 4.027621,-6.49566 4.107186,0 3.907177,-0.33408 3.920526,6.54843 l 0.01064,5.49011 3.978087,5.15937 c 2.187948,2.83766 4.167013,5.54061 4.397922,6.00657 0.847069,1.7093 1.150689,1.66879 -12.332304,1.64546 -6.639749,-0.0115 -12.221108,-0.0809 -12.403009,-0.15434 z m 22.158854,-1.83722 c 0,-0.0882 -0.367191,-0.62398 -0.815983,-1.19062 -0.766299,-0.96753 -0.902285,-1.03026 -2.233343,-1.03026 -0.779549,0 -1.490945,-0.11907 -1.580882,-0.26459 -0.09988,-0.16161 0.305932,-0.26458 1.042717,-0.26458 0.663432,0 1.206241,-0.0974 1.206241,-0.21649 0,-0.11906 -0.382667,-0.71437 -0.850371,-1.32291 -0.838758,-1.09132 -0.873082,-1.10643 -2.513541,-1.10643 -0.932392,0 -1.663171,-0.11626 -1.663171,-0.26459 0,-0.14552 0.595312,-0.26458 1.322916,-0.26458 0.727605,0 1.322917,-0.0698 1.322917,-0.15518 0,-0.0854 -0.37737,-0.68067 -0.838602,-1.32292 -0.826715,-1.15118 -0.86047,-1.16773 -2.38125,-1.16773 -0.852043,0 -1.542648,-0.11845 -1.542648,-0.26459 0,-0.14552 0.535781,-0.26458 1.190625,-0.26458 1.118117,0 1.525488,-0.29098 0.926042,-0.66146 -0.147679,-0.0913 -0.264584,-1.32566 -0.264584,-2.79374 v -2.63022 h -1.984375 -1.984374 v 2.43863 2.43862 l -3.972968,5.23429 -3.972967,5.2343 h 9.793801 c 5.38659,0 9.7938,-0.0722 9.7938,-0.16037 z M 53.383411,170.7998 v -1.98438 h -1.984375 -1.984374 v 1.98438 1.98437 h 1.984374 1.984375 z",
    id: "path388"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g585",
    transform: "matrix(1.2011179,0,0,1.1966959,-107.05998,-189.81752)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f48d1e",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    d: "m 177.18494,308.62307 c -0.37986,-0.20645 -1.18003,-1.18395 -1.77816,-2.17221 -1.55918,-2.57619 -3.28807,-4.66229 -8.3613,-10.08889 -5.14299,-5.50121 -7.091,-8.09086 -8.88857,-11.81629 -1.99051,-4.12531 -2.49415,-6.51818 -2.47809,-11.77396 0.0154,-5.02587 0.40009,-6.89426 2.21897,-10.77563 2.95125,-6.2978 8.26196,-10.75035 14.95072,-12.53482 2.78595,-0.74326 7.87851,-0.8257 10.60496,-0.17169 11.81843,2.83498 19.25365,13.92401 17.84507,26.61448 -0.82265,7.41157 -3.50157,12.21879 -11.49365,20.62492 -4.19968,4.41725 -6.84445,7.63334 -8.24074,10.02089 -1.36149,2.32803 -2.72374,2.97295 -4.37921,2.0732 z m 5.71322,-20.14542 c 5.85491,-1.5036 10.56563,-6.24065 12.19817,-12.26635 0.62016,-2.28901 0.62239,-6.43594 0.005,-8.70834 -1.64337,-6.04555 -6.45493,-10.75802 -12.5952,-12.33582 -2.3644,-0.60755 -7.13446,-0.41648 -9.45118,0.37857 -5.0802,1.74344 -9.09561,5.79976 -10.95614,11.06775 -0.7964,2.25497 -0.97263,6.63161 -0.36759,9.12898 1.64617,6.79474 7.31322,12.06351 14.16032,13.16514 1.82168,0.29308 4.93554,0.10203 7.00694,-0.42993 z",
    id: "path587"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapQualito);
export default __webpack_public_path__ + "static/media/map_qualito.4a325ee48233c1587756c6e420eb28b0.svg";
export { ForwardRef as ReactComponent };